import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from 'pages/home';
import CostingCalculator from 'pages/tools/CostingCalculator';
import ErrorBoundary from 'components/ErrorBoundary';
import PageTitle from 'components/PageTitle';
import { ROUTES } from 'utils/constants';

// Redirect component that preserves query parameters
function RedirectWithQuery({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
}

function App() {
  return (
    <ErrorBoundary>
      <PageTitle />
      <Routes>
        {/* Public routes */}
        <Route path={ROUTES.HOME} element={<Home />} />
        <Route
          path={ROUTES.TOOLS.COSTING_CALCULATOR}
          element={<CostingCalculator />}
        />
        {/* Redirect from old path to new path (preserves query parameters) */}
        <Route
          path="/tools/costing-calculator"
          element={<RedirectWithQuery to={ROUTES.TOOLS.COSTING_CALCULATOR} />}
        />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
